import React, { useState } from "react";
import style from "./tooltip.module.scss";

const Tooltip = (props) => {
    const [isShown, setIsShown] = useState(false);
    return (
        <>
            <div
                className={style.icon}
                onMouseOver={() => setIsShown(true)}
                onMouseOut={() => setIsShown(false)}
            >h
            </div>
            {isShown && (
                <div className={style.tooltip + ' ' + style['tooltip' + props.direction]}>
                    <pre className={style.tooltiptext}>{props.text}</pre>
                </div>
            )}
        </>
    );
}

export default Tooltip;